export default __webpack_public_path__ + "static/social-turismo_en-22e9c5c8d376a7761ab89fa6671d460f.png";